import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const MarketIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 20 20"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M2.5 2.5H7.5V7.5H2.5V2.5Z" fill="white" />
			<path d="M12.5 2.5H17.5V7.5H12.5V2.5Z" fill="white" />
			<path d="M2.5 12.5H7.5V17.5H2.5V12.5Z" fill="white" />
			<path d="M12.5 12.5H17.5V17.5H12.5V12.5Z" fill="white" />
		</svg>
	)
}

export default MarketIcon
